import Vue from 'vue'
import Mutations from '@/store/data/mutations'
export default {
  namespaced: true,
  state: {
    filterBy: "",
    filterCol: "",
    filterBy2: "",
    filterCol2: "",
    filterStatus: null,
    tippingDockets: [],
    selected: [],
    selectedAll: false,
    pagination: {},
    fetchTippingDockets: false
  },
  mutations: Mutations,
  actions: {
  },
  getters: {
  }
}